export default "__VITE_ASSET__670c741f__"